import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Spin, message } from 'antd';
import { gql, useMutation, useQuery } from '@apollo/client';

import ErrorBoundary from '../../components/Utils/ErrorBoundary';
// import * as Constants from './constants';

// import { doGetEmployeeById } from './employeeSlice';
import { EmployeeNew } from '../../components/Employee';

import { EMPLOYEE_ALL_FIELDS } from '../../apollo/fragments';
import {
  DESIGNATIONS_OPTION_QUERY,
  LOCATIONS_OPTIONS_QUERY,
  PORTFOLIO_OPTIONS_QUERY,
} from '../../apollo/queries';
import * as Config from '../../appConfig';
import './styles.css';

const CREATE_EMPLOYEE_QUERY = gql`
  ${EMPLOYEE_ALL_FIELDS}
  mutation CreateEmployee($input: CreateEmployeeInput) {
    createEmployee(input: $input) {
      ...EmployeeFields
    }
  }
`;

const EmployeeAdd = ({ employee, onCancelClick, onEmployeeCreation }) => {
  const [createEmployee, { loading: mutationLoading }] = useMutation(
    CREATE_EMPLOYEE_QUERY,
    {
      onCompleted({ createEmployee }) {
        if (createEmployee) {
          onEmployeeCreation(createEmployee);
        }
      },
    }
  );
  const { user } = useSelector((state) => state.login);
  const { loading: loadingD, data: designations } = useQuery(
    DESIGNATIONS_OPTION_QUERY
  );
  const { loading: loadingR, data: locations } = useQuery(
    LOCATIONS_OPTIONS_QUERY,
    {
      variables: {
        userId: user.id,
      },
    }
  );
  const { loading: loadingP, data: portfolios } = useQuery(
    PORTFOLIO_OPTIONS_QUERY
  );

  const onBasicInfoUpdate = (values, callBack) => {
    console.log('onBasicInfoAdd triggered with : ', values);
    createEmployee({
      variables: {
        input: {
          first_name: values.first_name,
          last_name: values.last_name,
          designation_id: parseInt(values.designation),
          location_id: values.location && parseInt(values.location[1]),
          portfolio_id: parseInt(values.portfolio),
          date_of_joining:
            values.date_of_joining &&
            values.date_of_joining.format(Config.DATE_FORMAT_SERVER),
          aadhar: values.aadhar,
          pan: values.pan,
        },
      },
    }).catch((e) => {
      console.log('mutationError ////', e, e.messgae, e.graphQLErrors);
      let error = 'Some error occured, Please try again later!!!';
      if (e.graphQLErrors) {
        e.graphQLErrors.forEach(({ extensions, message }) => {
          const { category, validation } = extensions;
          if (category === 'validation') {
            error = Object.keys(validation).map((field) => {
              return <span>{validation[field][0].replace('input.', '')}</span>;
            });
            if (callBack) {
              callBack({
                type: 'validation',
                message: error,
                field: 'aadhar',
              });
            }
          } else {
            error = message;
          }
        });
      }
      message.error(error);
    });
  };

  // useEffect(() => {
  //   if (mutationError) {
  //     console.log("mutationError ////", mutationError);
  //   }
  // }, mutationError);

  return (
    <ErrorBoundary>
      <Spin spinning={mutationLoading || loadingD || loadingR || loadingP}>
        <EmployeeNew
          employee={null}
          designations={designations && designations.designations}
          locations={locations && locations.locations}
          portfolios={portfolios && portfolios.portfolios}
          onBasicInfoUpdate={onBasicInfoUpdate}
          onCancelClick={onCancelClick}
          ability={user && user.ability}
        />
      </Spin>
    </ErrorBoundary>
  );
};

EmployeeAdd.defaultProps = {
  employee: null,
};

EmployeeAdd.propTypes = {
  employee: PropTypes.object,
  onCancelClick: PropTypes.func.isRequired,
  onEmployeeCreation: PropTypes.func.isRequired,
};

export default EmployeeAdd;
